import { getStateFromPath } from '@react-navigation/native';
import { AbstractPathResolver, PathResolveResult } from '../PathResolver';

export class DefaultStateResult {}

export class DefaultPathResolver extends AbstractPathResolver {
  resolveStateFromPath(): PathResolveResult {
    const { originalPath, options } = this.context;
    const res = this.parseQs(getStateFromPath(originalPath, options));
    if (res == null) return res;
    const state = new DefaultStateResult();
    Object.assign(state, res);
    return state as any;
  }
}
